import React, { ReactElement } from "react";

import { useSelector, shallowEqual } from "react-redux";

// Components
import Onboard from "./onboard.component";
import SignUp from "./signup.component";
import PreSignup from "./preSignup.component";
import { Redirect } from "react-router-dom";

export default (): ReactElement => {
  const { generalSettings } = useSelector(
    ({ generalSettings }) => ({ generalSettings }),
    shallowEqual
  );

  return (
    <>
      {!!generalSettings &&
        generalSettings.signInMethod === "emailPassword" && <SignUp />}

      {!!generalSettings &&
        generalSettings.signInMethod === "participantId" && <PreSignup />}

      {!!generalSettings && generalSettings.signInMethod === "anonymous" && (
        <Redirect to="/login" />
      )}
    </>
  );
};
